import API_CONFIG, { getApiUrl } from "../config/api";

export const uploadFile = async (file, userId, surveyId, questionId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("user_id", userId);
  formData.append("survey_id", surveyId);
  formData.append("question_id", questionId);

  try {
    const response = await fetch(
      getApiUrl(API_CONFIG.ENDPOINTS.SURVEYS.UPLOAD_FILE),
      {
        method: "POST",
        body: formData,
      }
    );

    const data = await response.json();
    if (!data.success) {
      throw new Error(data.message);
    }

    return data.file.url; // Return the file URL
  } catch (error) {
    console.error("File upload error:", error);
    throw error;
  }
};
